angular.module('eatself')
.directive('triggerableTooltip', function($timeout){
	// Runs during compile
	return {
		// name: '',
		// priority: 1,
		// terminal: true,
		// scope: {}, // {} = isolate, true = child, false/undefined = no change
		// controller: function($scope, $element, $attrs, $transclude) {},
		// require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
		// restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
		// template: '',
		// templateUrl: '',
		// replace: true,
		// transclude: true,
		// compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
		link: function($scope, iElm, iAttrs, controller) {
			iElm.tooltip({
				title: iAttrs.triggerableTooltip,
				trigger: 'manual',
				template: '<div class="tooltip '+iAttrs.triggerableTooltipClass+'" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
			})
			// iElm.tooltip('show')
			iAttrs.$observe('triggerableTooltip',function(newVal, oldVal) {
				iElm.data('bs.tooltip').options.title = newVal
				if (iElm.data('bs.tooltip').tip().hasClass('in'))
					iElm.tooltip('show')
			})
			$scope.$watch(iAttrs.triggerableTooltipShow, function(newVal, oldVal) {
				iElm.tooltip(newVal?'show':'hide')
			})
		}
	};
});